import { faLandmark, faCalendar, faNewspaper, type IconDefinition } from '@fortawesome/free-solid-svg-icons'

export type Category = 'sightseeing' | 'events' | 'blog'

export interface CategoryMeta {
  icon: IconDefinition
  variant: 'brand' | 'warning' | 'success'
}

/** `ButtonLink` variants in the color of a category, for links of category-colored blocks. */
export const BUTTON_LINK_VARIANTS = { brand: 'button-brand', warning: 'button-warning', success: 'button-success' } as const
export const OUTLINE_BUTTON_LINK_VARIANTS = {
  brand: 'button-brand-outline',
  warning: 'button-warning-outline',
  success: 'button-success-outline',
} as const

export const CATEGORIES: Record<Category, CategoryMeta> = {
  sightseeing: { icon: faLandmark, variant: 'brand' },
  events: { icon: faCalendar, variant: 'warning' },
  blog: { icon: faNewspaper, variant: 'success' },
}
